import React from 'react';
import './Cookiepolicy.css';
import Header from './Header';
import Footer from './Footer';

const Cookiepolicy = () => {
    return (
        <div>
            <Header />
            <div className="nd-cookie-page">
                <div className="nd-cookie-container container">
                    <div className="nd-cookie-hero">
                        <div className="nd-cookie-badge">Cookie & Tracking Policy</div>
                        <h1 className="nd-cookie-title">Cookie Policy</h1>
                        <div className="nd-cookie-effective">Effective Date:</div>
                    </div>

                    <div className="nd-cookie-cards-stack">
                        {/* Section 1 */}
                        <div className="nd-cookie-card">
                            <div className="nd-cookie-card-header">
                                <span className="nd-cookie-num">01</span>
                                <h5><strong>1. Introduction</strong></h5>
                            </div>
                            <div className="nd-cookie-card-body">
                                <p>This Cookie Policy explains how N D Techland Private Limited uses cookies and similar technologies on our website. By using our website, you consent to the use of cookies in accordance with this policy.</p>
                            </div>
                        </div>

                        {/* Section 2 */}
                        <div className="nd-cookie-card">
                            <div className="nd-cookie-card-header">
                                <span className="nd-cookie-num">02</span>
                                <h5><strong>2. What Are Cookies?</strong></h5>
                            </div>
                            <div className="nd-cookie-card-body">
                                <p>Cookies are small text files that are placed on your device when you visit a website. They help us recognize your device, remember your preferences, and improve your overall experience on our site.</p>
                            </div>
                        </div>

                        {/* Section 3 */}
                        <div className="nd-cookie-card">
                            <div className="nd-cookie-card-header">
                                <span className="nd-cookie-num">03</span>
                                <h5><strong>3. Types of Cookies We Use</strong></h5>
                            </div>
                            <div className="nd-cookie-card-body">
                                <div className="nd-cookie-types-grid">
                                    <div className="nd-cookie-type-box">
                                        <h6>Essential Cookies:</h6>
                                        <p>These cookies are necessary for the website to function properly. They enable basic features like page navigation and access to secure areas of the site.</p>
                                    </div>
                                    <div className="nd-cookie-type-box">
                                        <h6>Analytical Cookies:</h6>
                                        <p>These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.</p>
                                    </div>
                                    <div className="nd-cookie-type-box">
                                        <h6>Functional Cookies:</h6>
                                        <p>These cookies allow the website to remember your preferences, such as your language or region, and provide enhanced features.</p>
                                    </div>
                                    <div className="nd-cookie-type-box">
                                        <h6>Marketing Cookies:</h6>
                                        <p>These cookies track your online activity to help us deliver more relevant advertisements.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 4 */}
                        <div className="nd-cookie-card">
                            <div className="nd-cookie-card-header">
                                <span className="nd-cookie-num">04</span>
                                <h5><strong>4. Managing Cookies</strong></h5>
                            </div>
                            <div className="nd-cookie-card-body">
                                <p>You can manage your cookie preferences through your browser settings. Most browsers allow you to block or delete cookies, but doing so may affect your ability to use certain features of our website.</p>
                            </div>
                        </div>

                        {/* Section 5 */}
                        <div className="nd-cookie-card">
                            <div className="nd-cookie-card-header">
                                <span className="nd-cookie-num">05</span>
                                <h5><strong>5. Third-Party Cookies</strong></h5>
                            </div>
                            <div className="nd-cookie-card-body">
                                <p>We may also allow third-party service providers to place cookies on your device to help us analyze website traffic or deliver targeted advertisements. These third parties have their own privacy policies, and we encourage you to review them.</p>
                            </div>
                        </div>

                        {/* Section 6 */}
                        <div className="nd-cookie-card">
                            <div className="nd-cookie-card-header">
                                <span className="nd-cookie-num">06</span>
                                <h5><strong>6. Changes to This Policy</strong></h5>
                            </div>
                            <div className="nd-cookie-card-body">
                                <p>We may update this Cookie Policy from time to time to reflect changes in our use of cookies. Any updates will be posted on our website, and we recommend reviewing this policy regularly.</p>
                            </div>
                        </div>

                        {/* Section 7 */}
                        <div className="nd-cookie-card nd-cookie-contact-card">
                            <div className="nd-cookie-card-header">
                                <span className="nd-cookie-num">07</span>
                                <h5><strong>7. Contact Us</strong></h5>
                            </div>
                            <div className="nd-cookie-card-body">
                                <p>If you have any questions about our use of cookies, please contact us at <a href="mailto:support@ndtechland.com">support@ndtechland.com</a>.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Cookiepolicy;
